<template>
  <BaseButton
    block
    color="primary"
    elevation="0"
    x-large
    :disabled="disabled"
    class="meta-play-button"
    @click="togglePlay()"
  >
    <BaseSpriteIcon :custom-class="customClass" :icon-name="iconName" />
    {{ label }}
  </BaseButton>
</template>
<script>
import BaseButton from '@/components/base/BaseButton/BaseButton';
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import GoogleAnalyticsUtils from '@/services/utils/GoogleAnalyticsUtils';
import PublicationsTypesEnum from '@shared/enums/PublicationsTypesEnum';

export default {
  components: {
    BaseButton,
    BaseSpriteIcon
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    bookType: {
      type: String,
      required: false,
      default: PublicationsTypesEnum.BOOK
    }
  },
  computed: {
    isPlaying() {
      return this.$store.state.PlaybackStore.isPlaying;
    },
    label() {
      return this.isPlaying
        ? this.$t('MetaBlock.pauseButton.label')
        : this.$t(`MetaBlock.playButton${this.bookType}.label`);
    },
    iconName() {
      return this.isPlaying ? 'ico-stop' : 'ico-book-info-read-solid';
    },
    customClass() {
      return this.isPlaying ? '' : 'default-state';
    }
  },
  methods: {
    togglePlay() {
      this.$emit('play-button-clicked');

      if (this.isPlaying) {
        GoogleAnalyticsUtils.trackEvent('book', 'pausePlayMeta');
        this.$store.dispatch('PlaybackStore/pause');
      } else {
        const paraId = this.$store.getters[
          'PublicationStore/getFirstAudioParagraph'
        ]();
        GoogleAnalyticsUtils.trackEvent('book', 'startPlayMeta');
        this.$store.dispatch('PlaybackStore/playAudioFromMetaBlock', {
          paraId
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.meta-play-button {
  svg {
    width: 16px;
    height: 16px;
    fill: #fff;

    &.default-state {
      width: 20px;
      height: 20px;
      border: solid 2px #fff;
      border-radius: 12px;
    }
  }
}
</style>
